<ng-container [ngSwitch]="eachControl?.type">
  <ng-container *ngSwitchCase="'textbox'">
    <app-rat-input [question]="question" [eachControl]="eachControl" [form]="form" [controlIndex]="controlIndex"
      (inputChanged)="valueChanged($event)" [isSubmittedEvent]="saveNextSubject.asObservable()"></app-rat-input>
  </ng-container>
  <ng-container *ngSwitchCase="'dropdown'">
    <app-rat-select [question]="question" [eachControl]="eachControl" [form]="form" [controlIndex]="controlIndex"
      [assessmentType]="assessmentType" (inputChanged)="valueChanged($event)"
      [isSubmittedEvent]="saveNextSubject.asObservable()"></app-rat-select>
  </ng-container>
  <ng-container *ngSwitchCase="'multiselect'">
    <ng-container *ngIf="eachControl.options.length > 0">
      <app-rat-multiselect [question]="question" [eachControl]="eachControl" [form]="form" [controlIndex]="controlIndex"
        [assessmentType]="assessmentType" (inputChanged)="valueChanged($event)"
        [isSubmittedEvent]="saveNextSubject.asObservable()"></app-rat-multiselect>
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'country'">
    <ng-container *ngIf="eachControl.options.length > 0">
      <app-rat-multiselect [question]="question" [eachControl]="eachControl" [form]="form" [controlIndex]="controlIndex"
        [assessmentType]="assessmentType" (inputChanged)="valueChanged($event)"
        [isSubmittedEvent]="saveNextSubject.asObservable()"></app-rat-multiselect>
    </ng-container>
  </ng-container>
  <ng-container *ngSwitchCase="'button'">
    <app-rat-button [question]="question" [eachControl]="eachControl" [controlIndex]="controlIndex"
      [form]="form"></app-rat-button>
  </ng-container>
</ng-container>